import styled from "styled-components";

export const PoolItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
